export const videoAccount = '921483724001';
export const videoId = '6193641712001';
export const videoPlayerId = '9czXFsoGV';
